import { rem2px } from "@/utils/tools";
import { useRef } from "react";

const useCreatDivider = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  const getDividersImg = (itemCount = 6) => {
    const canvas = canvasRef.current;
    if (!canvas) {
      throw new Error("Canvas element not found");
    }
    const ctx = canvas.getContext("2d");
    if (!ctx) {
      throw new Error("Canvas context not found");
    }

    const radius = canvas.width / 2;
    const gapRadius = rem2px(170);
    const outerGap = rem2px(50);
    const angle = (2 * Math.PI) / itemCount;

    // 核心修改：计算单数时的角度偏移
    let startOffset = 0;
    const middleIndex = (itemCount - 1) / 2;
    startOffset = Math.PI / 2 - middleIndex * angle; // 对准6点钟方向

    ctx.strokeStyle = "rgba(0,0,0, 0.2)";
    ctx.lineWidth = rem2px(1);
    // 清空画布
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    for (let i = 0; i < itemCount; i++) {
      const startAngle = angle * i + startOffset;

      // 坐标计算保持不变
      const startX = radius + gapRadius * Math.cos(startAngle);
      const startY = radius + gapRadius * Math.sin(startAngle);
      const endX = radius + (radius - outerGap) * Math.cos(startAngle);
      const endY = radius + (radius - outerGap) * Math.sin(startAngle);

      ctx.beginPath();
      ctx.moveTo(startX, startY);
      ctx.lineTo(endX, endY);
      ctx.stroke();
    }

    return canvas.toDataURL();
  };

  return { getDividersImg, canvasRef };
};

export default useCreatDivider;
